var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort-icon"},[_c('div',{staticClass:"sort-icon__up",class:_vm.state}),_c('div',{staticClass:"sort-icon__down",class:_vm.state})])}
var staticRenderFns = []

export { render, staticRenderFns }